import React from 'react';
import { FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { Container, Flex, IconButton } from '../../../components';
import { useStyles } from '../../../system';
import { useThemedValueSwitch } from '../../../hooks';
export var FooterMainLogoContainer = _ref => {
  var {
    socialLinks,
    missionDescription,
    children
  } = _ref;
  var styles = useStyles();
  var {
    isEngland,
    isTQ
  } = useThemedValueSwitch();
  var showMissionDescription = missionDescription && missionDescription.length > 0;
  var showSocialIcons = socialLinks && (isEngland || isTQ);
  return /*#__PURE__*/React.createElement(Container, {
    sx: styles.mainLogoContainer
  }, children, isEngland && showMissionDescription && /*#__PURE__*/React.createElement("p", null, missionDescription), showSocialIcons && /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "LinkedIn",
    as: "a",
    href: socialLinks.linkedIn.href,
    icon: /*#__PURE__*/React.createElement(FaLinkedinIn, null),
    title: socialLinks.linkedIn.title,
    sx: styles.socialIcon
  }), /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Facebook",
    as: "a",
    href: socialLinks.facebook.href,
    icon: /*#__PURE__*/React.createElement(FaFacebookF, null),
    title: socialLinks.facebook.title,
    mx: '0.5rem',
    sx: styles.socialIcon
  }), /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Twitter",
    as: "a",
    href: socialLinks.twitter.href,
    icon: /*#__PURE__*/React.createElement(FaTwitter, null),
    title: socialLinks.twitter.title,
    sx: styles.socialIcon
  })));
};
FooterMainLogoContainer.displayName = 'FooterMainLogoContainer';